import { GetLocalizationEffects } from './get-localization.effects';
import { RoutingEffects } from './routing.effects';
import { ToolEffects } from './tool.effects';
import { ToastEffects } from './toast.effects';

export const CoreEffects = [GetLocalizationEffects, ToolEffects, RoutingEffects, ToastEffects];
